import Link from '~/components/Link'

import { getCollection } from '~/content/collections'
import MainPage from './projects/templates/MainPageTemplate'

// Index of canvas-based experiments. Each links to /sandbox/:slug.
export default function Sandbox() {
	const experiments = getCollection('experiments')

	return (
		<MainPage>
			<div className="h-full overflow-y-auto px-3 py-2 backdrop-blur-sm">
				<h1 className="font-bold text-3xl mt-2 mb-6">Lab</h1>
				<ul className="list-none m-0 p-0 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
					{experiments.map(({ meta }) => (
						<li key={meta.slug} className="m-0">
							<Link
								href={`/sandbox/${meta.slug}`}
								className="block w-full aspect-video overflow-hidden bg-black relative group no-underline"
							>
								{meta.cover && (
									<img
										src={meta.cover}
										alt={meta.name}
										loading="lazy"
										className="absolute inset-0 w-full h-full object-cover transition duration-500 group-hover:scale-105"
									/>
								)}
								<span className="absolute inset-0 flex flex-col justify-end p-3 bg-tile-fade">
									<span className="font-semibold text-white leading-tight">{meta.name}</span>
									<span className="text-sm text-white/70">{meta.excerpt}</span>
								</span>
							</Link>
						</li>
					))}
				</ul>
			</div>
		</MainPage>
	)
}
